import { render, staticRenderFns } from "./detailview.vue?vue&type=template&id=e799a002&scoped=true"
import script from "./detailview.vue?vue&type=script&lang=ts"
export * from "./detailview.vue?vue&type=script&lang=ts"
import style0 from "./detailview.vue?vue&type=style&index=0&id=e799a002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e799a002",
  null
  
)

export default component.exports